module.exports = __webpack_public_path__ + "media/images/categories/headers/environment-bff11f20c26fd79791ea9cd2eff7aa1f.jpg";